import { render, staticRenderFns } from "./NetellerDeposit.vue?vue&type=template&id=37c36478"
import script from "./NetellerDeposit.vue?vue&type=script&lang=js"
export * from "./NetellerDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports